import { skipToken, } from '@tanstack/react-query';
import { useGetApiTimesheetsByUuidRows, } from '../../generated/sitComponents';
import { CACHE_TIMES } from '../query';
export function useGetTimesheetRows(variables, options) {
    return useGetApiTimesheetsByUuidRows(variables === skipToken || !variables.pathParams.id
        ? skipToken
        : {
            ...variables,
            pathParams: {
                id: variables.pathParams.id,
            },
        }, {
        staleTime: CACHE_TIMES.FIVE_SECONDS,
        gcTime: CACHE_TIMES.TWO_MINUTES,
        ...options,
    });
}
//# sourceMappingURL=use-get-timesheet-rows.js.map